export const locale = {
  lang: 'tr',
  data: {
    PROJECT_MANAGEMENT: {
      TITLE: 'Karbon yolculuğunuzu tamamlayın',
      BACK: 'Geri',
      STEP: 'Adım',
      TASKS: 'Görev',
      COMPLETED: 'Tamamlandı',
      COMPLETED_SHORT: 'Tamamlandı',
      NO_QUESTIONS_STEP: 'Bu adımda henüz görünür soru yok.',
      ANSWER: 'Cevapla',
      QUESTION_TITLE: 'Soru',
      STEP_MINI: 'Adım',
      ANSWER_LABEL: 'Cevabınız',
      UNSUPPORTED_TYPE: 'Desteklenmeyen cevap tipi',
      CANCEL: 'İptal',
      PROCEED: 'İlerle',
      LOAD_FAILED: 'Proje yüklenemedi.',
      SAVED: 'Cevap kaydedildi.',
      SAVE_FAILED: 'Cevap kaydedilemedi.',
      ANSWER_REQUIRED: 'Zorunlu alanları doldurun.',
      INVALID_NUMBER: 'Geçerli bir sayı girin.',
      PHASE_QUESTIONS_TITLE: 'Analiz',
      PHASE_QUESTIONS_SUB:
        'Profilinizi oluşturun; görevler cevaplarınıza göre oluşur.',
      PHASE_TASKS_TITLE: 'Görev Panosu',
      PHASE_TASKS_SUB: 'Cevaplardan oluşan görevleri tamamlayın ve izleyin.',
      PHASE_REPORT_TITLE: 'Rapor oluşturulması',
      PHASE_REPORT_SUB: 'Görevler tamamlandıktan sonra nihai çıktıyı hazırlayın.',
      STAGES_LABEL: 'Aşama',
      QUESTIONS_LABEL: 'soru',
      WORKFLOW_TASKS_LABEL: 'Görev',
      PERCENT_DONE: 'Tamamlandı',
      TASKS_EMPTY:
        'Henüz görev yok. Görevler için önce soruları tamamlayın.',
      TASKS_LOAD_FAILED:
        'Görevler yüklenemedi. Sorulara devam edebilirsiniz.',
      TASKS_LOADING: 'Görevler yükleniyor…',
      TASK_STATUS: 'Görev durumu :',
      TASK_STATUS_COMPLETED: 'Tamamlandı',
      TASK_STATUS_IN_PROGRESS: 'Devam ediyor',
      TASK_STATUS_PENDING: 'Beklemede',
      NO_TASKS_IN_STEP: 'Bu adımda henüz görev yok.',
      TASK_STATUS_SAVED: 'Görev durumu güncellendi.',
      UPDATE_TASK_FAILED: 'Görev durumu güncellenemedi.',
      PROJECT_COMPLETED_TASK_STATUS_LOCKED:
        'Proje tamamlandığı için görev durumları değiştirilemez.',
      URL_TASK_FLOAT_APPLY: 'Durumu kaydet',
      URL_TASK_FLOAT_DONE: 'Tamamlandı',
      URL_TASK_FLOAT_HINT:
        'Başlığı sürükleyerek taşınır. Aktif projedeki URL görevlerini bu sayfada takip edersiniz.',
      URL_TASK_FLOAT_DISMISS: 'Kapat',
    },
  },
};
